Blackprint.CodeRoute = {
	MustHave: '__MustHave',
	Optional: '__Optional',
	None: '__None',
};